import React from 'react';
import { Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const renderHeadline = (props) => {
  if (props.fields.Headline !== undefined) {
    return <Text field={props.fields.Headline} />;
  } else if (props.fields.HeadlineRTE !== undefined) {
    return <RichText tabIndex="" field={props.fields.HeadlineRTE} />;
  }
  // Optionally, if neither field is defined, return null.
  console.warn(
    'renderField/headline.js: neither fields.Headline nor fields.HeadlineRTE is defined. Current fields:',
    props.fields
  );

  return null;
};

const Headline = (props) => {
  switch (props.fields.HeadingType?.value) {
    case 'H1':
      return (
        <h1
          className={`${props.className} u-text-lg-1 u-text-md-1 u-text-sm-1`}
          data-component="PrimaryHeading"
          tabIndex="0"
        >
          {renderHeadline(props)}
        </h1>
      );
    case 'H2':
      return (
        <h2
          className={`${props.className} u-text-lg-2 u-text-md-2 u-text-sm-2`}
          data-component="PrimaryHeading"
          tabIndex="0"
        >
          {renderHeadline(props)}
        </h2>
      );
    case 'H3':
      return (
        <h3
          className={`${props.className} u-text-lg3 u-text-md-3 u-text-sm-3`}
          data-component="PrimaryHeading"
          tabIndex="0"
        >
          {renderHeadline(props)}
        </h3>
      );
    case 'Div H1':
      return (
        <div
          className={`${props.className} u-text-lg-1 u-text-md-1 u-text-sm-1`}
          data-component="PrimaryHeading"
          tabIndex="0"
        >
          {renderHeadline(props)}
        </div>
      );
    case 'Div H3':
      return (
        <div
          className={`${props.className} u-text-lg-3 u-text-md-3 u-text-sm-3`}
          data-component="PrimaryHeading"
          tabIndex="0"
        >
          {renderHeadline(props)}
        </div>
      );
    case 'Div H2':
    default:
      return (
        <div
          className={`${props.className} u-text-lg-2 u-text-md-2 u-text-sm-2`}
          data-component="PrimaryHeading"
          tabIndex="0"
        >
          {renderHeadline(props)}
        </div>
      );
  }
};

export default withSitecoreContext()(Headline);
